import { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import '../AllCss/BackToTop.css';

function BackToTop() {
  const { t } = useLocale();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      className="back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label={t('common.backToTop')}
    >
      <ChevronUp size={22} />
    </button>
  );
}

export default BackToTop;
